// Module
var code = "<react-component name=\"GradingEventMessages\"></react-component>\n";
// Exports
module.exports = code;